import "./MatrixFII.module.css";
import Header from "@/reusable_sections/Header";
import MatrixHero from "./sections/MatrixHero";
import Footer from "@/reusable_sections/Footer";
export default function MatrixFIIPage() {
  return <div>
      <Header />
      <MatrixHero />
      <Footer />
    </div>;
}